export function reportClick(data) {
  window.xy_runtime_utils.reporter.report('click', data);
}
//# sourceMappingURL=report.js.map
